import { Injectable, inject } from '@angular/core';
import { AssetsRiskByCategoryGQL, IemRiskByCategoryGQL, IemRiskScoreGQL, RiskScoreGQL } from '@uigy/generated/graphql';
import { map, Observable } from 'rxjs';
import Utils from '@uigy/utils';
import { riskAssetsByCategory } from '@uigy/shared/components/risk-score/models/interfaces';
import { IemService } from '@uigy/shared/services/iem.service';

@Injectable({
  providedIn: 'root',
})
export class RiskScoreService {
  private assetsRiskByCategoryGQL = inject(AssetsRiskByCategoryGQL);
  private iemRiskByCategoryGQL = inject(IemRiskByCategoryGQL);
  private riskScoreGQL = inject(RiskScoreGQL);
  private iemRiskScore = inject(IemRiskScoreGQL);
  private iemService = inject(IemService);


  public getRiskScore(): Observable<number> {
    if (this.iemService.isIEM()) {
      return this.iemRiskScore.fetch().pipe(
        map(
          response => Utils.stripConnection(response?.data?.groupedAssetsRaw)[0]?.risk
        ),
      );
    } else {
      return this.riskScoreGQL.fetch().pipe(
        map(
          response => Utils.stripConnection(response?.data?.assetsRaw)[0]?.risk
        ),
      );
    }

  }

  public getAssetsRiskByCategory(): Observable<riskAssetsByCategory[]> {
    if (this.iemService.isIEM()) {
      return this.iemRiskByCategoryGQL.fetch().pipe(
        map(
          response => Utils.stripConnection(response?.data?.groupedAssetsRaw)
        )
      );
    } else {
      return this.assetsRiskByCategoryGQL.fetch().pipe(
        map(
          response => Utils.stripConnection(response?.data?.assetsRaw)
        )
      );
    }

  }
}
